import { FaWhatsapp } from "react-icons/fa";
import { decode } from "../config";

const FLOAT_POPUP = decode(window._env_?.FLOAT_POPUP);
const WHATSAPP_NUMBER = "+" + decode(window._env_?.WHATSAPP_NUMBER);
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, "")}`;

export default function WhatsAppFloatingButton() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="
        fixed z-[9999]
        bottom-2 right-3
        sm:bottom-4 sm:right-4
        group
      "
      aria-label="Chat on WhatsApp"
    >
      <div className="flex items-center gap-2">
        {/* 💬 Always visible text */}
        <span
          className="
            bg-gray-200 text-black text-xs sm:text-sm
            px-2 sm:px-3 py-1.5 sm:py-2
            rounded-lg shadow-lg
            whitespace-nowrap
          "
        >
          {FLOAT_POPUP}
        </span>

        {/* 🟢 WhatsApp Button */}
        <div
          className="
            flex items-center justify-center
            rounded-full bg-green-500 shadow-lg
            hover:bg-green-600 transition
            animate-ring
            w-12 h-12
            sm:w-16 sm:h-16
          "
        >
          <FaWhatsapp className="text-white text-2xl sm:text-4xl" />
        </div>
      </div>
    </a>
  );
}
